import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiResponse } from '../_models/api-response.model';
import { Page2Model } from '../_models/page2.model';
import { SettingsService } from './settings.service';

@Injectable()
export class Page2Service {
  public apiEndPoint: string; // = environment.SPECTRUM_API;
  key = environment.API_KEY as unknown as { value: '' };
  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private settingsService: SettingsService
  ) {
    this.apiEndPoint = this.settingsService.settings.SPECTRUM_API;
    this.route.data.subscribe(data => {
    });
  }

  getPage2Data(): Observable<Page2Model> {
    return this.http.get<ApiResponse>(`${this.apiEndPoint}/${this.key}/page2`).pipe(map(s => s.data));
  }

  updateGroups(model: Page2Model): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`${this.apiEndPoint}/${this.key}/page2`, model);
  }


}
